import clsx from "clsx";

import { useUser } from "@components/user-context";
import { formatting } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  formattedValue?: string | number;
}

export const CellMetricFormatter = <TData,>(props: TableCellProps<TData>) => {
  const { user } = useUser();
  return (
    <div
      className={clsx(
        "text-v2-primary h-full px-4 py-2.5 bg-inherit font-mono text-xs",
        "flex items-center justify-end",
      )}
      title={String(props.formattedValue) ?? String(props.cell.getValue())}
    >
      {formatting.formatMetric.approximate(
        Number(props.formattedValue ?? props.cell.getValue()),
        "dollars",
        {
          code: user.currencies.currentCurrency,
        },
      )}
    </div>
  );
};
